var map = {
	"./auditlog.cattle.io.auditpolicy": 21835,
	"./auditlog.cattle.io.auditpolicy.vue": 21835,
	"./autoscaling.horizontalpodautoscaler": 10623,
	"./autoscaling.horizontalpodautoscaler/": 10623,
	"./autoscaling.horizontalpodautoscaler/index": 10623,
	"./autoscaling.horizontalpodautoscaler/index.vue": 10623,
	"./catalog.cattle.io.app": 91079,
	"./catalog.cattle.io.app.vue": 91079,
	"./catalog.cattle.io.clusterrepo": 23584,
	"./catalog.cattle.io.clusterrepo.vue": 23584,
	"./compliance.cattle.io.clusterscan": 19284,
	"./compliance.cattle.io.clusterscan.vue": 19284,
	"./configmap": 77347,
	"./configmap.vue": 77347,
	"./constraints.gatekeeper.sh.constraint": 32267,
	"./constraints.gatekeeper.sh.constraint.vue": 32267,
	"./fleet.cattle.io.bundle": 52980,
	"./fleet.cattle.io.bundle.vue": 52980,
	"./fleet.cattle.io.cluster": 33824,
	"./fleet.cattle.io.cluster.vue": 33824,
	"./fleet.cattle.io.clustergroup": 32411,
	"./fleet.cattle.io.clustergroup.vue": 32411,
	"./fleet.cattle.io.gitrepo": 2363,
	"./fleet.cattle.io.gitrepo.vue": 2363,
	"./fleet.cattle.io.helmop": 92089,
	"./fleet.cattle.io.helmop.vue": 92089,
	"./harvesterhci.io.management.cluster": 56120,
	"./harvesterhci.io.management.cluster.vue": 56120,
	"./helm.cattle.io.projecthelmchart": 65309,
	"./helm.cattle.io.projecthelmchart.vue": 65309,
	"./management.cattle.io.fleetworkspace": 59071,
	"./management.cattle.io.fleetworkspace.vue": 59071,
	"./management.cattle.io.globalrole": 84998,
	"./management.cattle.io.globalrole.vue": 84998,
	"./management.cattle.io.oidcclient": 64496,
	"./management.cattle.io.oidcclient.vue": 64496,
	"./management.cattle.io.roletemplate": 3528,
	"./management.cattle.io.roletemplate.vue": 3528,
	"./management.cattle.io.user": 57898,
	"./management.cattle.io.user.vue": 57898,
	"./namespace": 88782,
	"./namespace.vue": 88782,
	"./networking.k8s.io.ingress": 81197,
	"./networking.k8s.io.ingress.vue": 81197,
	"./node": 45035,
	"./node.vue": 45035,
	"./pod": 22169,
	"./pod.vue": 22169,
	"./projectsecret": 44513,
	"./projectsecret.vue": 44513,
	"./provisioning.cattle.io.cluster": 37519,
	"./provisioning.cattle.io.cluster.vue": 37519,
	"./rbac.authorization.k8s.io.clusterrole": 5023,
	"./rbac.authorization.k8s.io.clusterrole.vue": 5023,
	"./rbac.authorization.k8s.io.role": 12379,
	"./rbac.authorization.k8s.io.role.vue": 12379,
	"./secret": 93431,
	"./secret.vue": 93431,
	"./service": 88741,
	"./service.vue": 88741,
	"./workload": 38274,
	"./workload/": 38274,
	"./workload/index": 38274,
	"./workload/index.vue": 38274
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__(id);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 77031;
module.exports = webpackAsyncContext;